import React, { Component } from 'react';
import FontAwesomeIcon from '@fortawesome/react-fontawesome';
import {
  Collapse,
  Col,
  Input,
  FormGroup,
  CustomInput,
  Label,
} from 'reactstrap';
import ToggleButton from 'react-toggle-button';

class SocialMediaConfig extends Component {
  constructor(props) {
    super(props);
    this.state = {
      title: '',
      link: '',
      id: '',
      is_active: false,
    };
  }

  componentWillReceiveProps(nextProps) {
    this.setState({
      title:
        nextProps.values && nextProps.values.title
          ? nextProps.values.title
          : '',
      link:
        nextProps.values && nextProps.values.link ? nextProps.values.link : '',
      id: nextProps.values && nextProps.values.id ? nextProps.values.id : '',
      is_active: nextProps.showSocialMedia,
    });
  }

  onTitleChange = e => {
    this.setState(
      {
        title: e.target.value,
      },
      () => {
        this.updateInformation();
      }
    );
  };

  onLinkChange = e => {
    this.setState(
      {
        link: e.target.value,
      },
      () => {
        this.updateInformation();
      }
    );
  };

  updateInformation = () => {
    const { id } = this.state;
    const { updateContent, data, type } = this.props;
    const newData = { ...this.state, [type]: data.type };

    if (!id) {
      delete newData['id'];
    }

    updateContent(data.type, newData);
  };

  render() {
    const { data, showSocialMedia, toggleSocialMedia } = this.props;
    const { label, icon } = data;
    const { title, link } = this.state;

    return (
      <div className="p-2 mt-4 row mb-1 bg-light">
        <div className="float-left w-100 p-3">
          <div className="float-left ml-3">
            <FontAwesomeIcon icon={icon} />
            <span>{label}</span>
          </div>
          <div className=" toggleButton float-right">
            <ToggleButton
              style={{ borderRadius: '5px' }}
              value={showSocialMedia}
              onToggle={toggleSocialMedia}
            />
          </div>
          <Collapse
            isOpen={showSocialMedia}
            onExiting={this.updateInformation}
            className="float-left w-100"
          >
            <Col md={{ size: 16 }} className="addon-input pl-2 pr-2">
              <div className="ml-2">
                <hr />
                <form autoComplete="off">
                  <FormGroup className="mb-3">
                    <label>Title</label>
                    <Input
                      type="text"
                      name="title"
                      placeholder="Enter the title"
                      required={true}
                      value={title}
                      onChange={this.onTitleChange}
                    />
                  </FormGroup>
                  <FormGroup className="mb-3">
                    <label>Link</label>
                    <Input
                      type="url"
                      name="url"
                      placeholder="Enter the link"
                      required={true}
                      value={link}
                      onChange={this.onLinkChange}
                    />
                  </FormGroup>
                  {// Todo 
                  /* <div className="media_checkbox " fluid>
                    <CustomInput
                      type="checkbox"
                      id="exampleCustomCheckbox"
                      name="l_address_checkbox"
                      checked={true}
                    />{' '}
                    <Label
                      for="addressCheckbox"
                      id="l_checkboxLabel"
                      className="cursor-pointer"
                    >
                      Include {title} icon
                    </Label>
                  </div> */}
                </form>
              </div>
            </Col>
          </Collapse>
        </div>
      </div>
    );
  }
}

export default SocialMediaConfig;



// WEBPACK FOOTER //
// ./src/components/businesses/tabs/info-edit/social-media/SocialMediaConfig.js